import { useEffect } from 'react';
import { NavLink } from 'react-router-dom';

import { Card } from '../../components/base/Card';
import { Button } from '../../components/base/Button';

import { usePageTitle } from '../../contexts/PageTitleContext';
import { useGlobalHardwareModelFilter } from '../../contexts/GlobalHardwareFilterContext';
import { GlobalHardwareModelFilterBanner } from '../../components/shared/GlobalHardwareModelFilterBanner';
import { Alert } from '../../components/base/Alert';
import { Info } from 'luxon';
import {
  ErrorAlert,
  InfoAlert,
  SuccessAlert,
  WarningAlert,
} from '../../components/shared/StyledAlerts';

export function SystemPage() {
  const { globalHardwareModelFilter } = useGlobalHardwareModelFilter();
  const { setPageTitle } = usePageTitle();

  useEffect(() => {
    setPageTitle('System');
  }, [setPageTitle]);

  return (
    <div className="grid grid-cols-1 gap-y-6">
      {globalHardwareModelFilter && (
        <Card>
          <GlobalHardwareModelFilterBanner />
        </Card>
      )}
      <Card title="Global">
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-4 gap-2 sm:gap-6 sm:gap-y-4">
          <NavLink to="datapoint">
            <Button fullWidth size="lg">
              Data Points
            </Button>
          </NavLink>
          <NavLink to="action">
            <Button fullWidth size="lg">
              Appliance Actions
            </Button>
          </NavLink>
          <NavLink to="datapoint/functions">
            <Button fullWidth size="lg">
              Transformation Functions
            </Button>
          </NavLink>
          <NavLink to="fault/actions">
            <Button fullWidth size="lg">
              Fault Actions
            </Button>
          </NavLink>
          <NavLink to="fault/causes">
            <Button fullWidth size="lg">
              Fault Causes
            </Button>
          </NavLink>
        </div>
      </Card>

      <Card title="Configuration">
        {!globalHardwareModelFilter && (
          <div className="mt-6">
            <p className="italic text-gray-800 dark:text-gray-400">
              Some features are unavailable until a hardware model filter has
              been applied
            </p>
          </div>
        )}
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-4 gap-2 sm:gap-6 sm:gap-y-4">
          <NavLink to="action/profiles">
            <Button fullWidth size="lg" disabled={!globalHardwareModelFilter}>
              Action Profiles
            </Button>
          </NavLink>
          <NavLink to="action/transformations">
            <Button fullWidth size="lg" disabled={!globalHardwareModelFilter}>
              Action Transformations
            </Button>
          </NavLink>
          <NavLink to="datapoint/profiles">
            <Button fullWidth size="lg" disabled={!globalHardwareModelFilter}>
              DataPoint Profiles
            </Button>
          </NavLink>
          <NavLink to="datapoint/options">
            <Button fullWidth size="lg" disabled={!globalHardwareModelFilter}>
              DataPoint Options
            </Button>
          </NavLink>
          <NavLink to="datapoint/transformations">
            <Button fullWidth size="lg" disabled={!globalHardwareModelFilter}>
              DataPoint Transformations
            </Button>
          </NavLink>
          <NavLink to="fault">
            <Button fullWidth size="lg" disabled={!globalHardwareModelFilter}>
              Fault Definitions
            </Button>
          </NavLink>
        </div>
      </Card>

      <Card title="Hardware">
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-4 gap-2 sm:gap-6 sm:gap-y-4">
          <NavLink to="hardware/types">
            <Button fullWidth size="lg">
              Types
            </Button>
          </NavLink>
          <NavLink to="hardware/manufacturers">
            <Button fullWidth size="lg">
              Manufacturers
            </Button>
          </NavLink>
          <NavLink to="hardware/models">
            <Button fullWidth size="lg">
              Models
            </Button>
          </NavLink>
        </div>
      </Card>

      <Card title="Job">
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-4 gap-2 sm:gap-6 sm:gap-y-4">
          <NavLink to="job/categories">
            <Button fullWidth size="lg">
              Categories
            </Button>
          </NavLink>
        </div>
      </Card>
    </div>
  );
}
